/* eslint-disable */
import Vue from 'vue'
// import * as VeeValidate from 'vee-validate'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)
